import MenuItem from '../MenuItem'
import LocalProductsIcon from '../../components/Icons/LocalProductsIcon'
import labels from '../../models/labels.json'

class LocalProductsItem extends MenuItem {
  constructor(indice, sendActivity, color) {
    super(
      indice,
      labels.localProducts,
      undefined,
      undefined,
      true,
      'localProducts'
    )

    this.clickHandler = (): void => {
      const activity = {
        type: 'event',
        name: 'Hospitality.ShowAllProducts'
      }
      sendActivity(activity)
    }

    this.icon = LocalProductsIcon({ className: 'rf-h-full rf-w-full', color })
  }
}

export default LocalProductsItem
